module.exports = require("instafeed.js");


//////////////////
// WEBPACK FOOTER
// external "instafeed.js"
// module id = 281
// module chunks = 0